module.exports = __webpack_public_path__ + "static/media/Hot Dog Vendor.4b1b1930.jpg";